<!-- Normal mode (inline) -->
@if (!isFloating) {
<div class="language-switcher">
    <button type="button"
        (click)="setLang('es')"
        [class.active]="isActive()('es')"
        class="lang-button"
    >
        🇪🇸 Español
    </button>
    <button type="button"
        (click)="setLang('ca')"
        [class.active]="isActive()('ca')"
        class="lang-button"
    >
        Català
    </button>
    <button type="button"
        (click)="setLang('en')"
        [class.active]="isActive()('en')"
        class="lang-button"
    >
        🇬🇧 English
    </button>
    <button type="button"
        (click)="setLang('fr')"
        [class.active]="isActive()('fr')"
        class="lang-button"
    >
        🇫🇷 Français
    </button>
    <button type="button"
        (click)="setLang('zh')"
        [class.active]="isActive()('zh')"
        class="lang-button"
    >
        🇨🇳 中文
    </button>
</div>
}

<!-- Floating mode -->
@if (isFloating) {
<div class="floating-lang-switcher">
    <button type="button" 
        class="floating-toggle-btn"
        (click)="toggleFloatingMenu()"
        [class.open]="isFloatingMenuOpen()"
    >
        <span class="current-flag">{{ getCurrentFlag() }}</span>
        <i class="pi pi-chevron-up" [class.rotated]="isFloatingMenuOpen()"></i>
    </button>
    
    @if (isFloatingMenuOpen()) {
    <div class="floating-menu">
        <button type="button"
            (click)="selectLanguage('es')"
            [class.active]="isActive()('es')"
            class="floating-lang-option"
        >
            🇪🇸 Español
        </button>
        <button type="button"
            (click)="selectLanguage('ca')"
            [class.active]="isActive()('ca')"
            class="floating-lang-option"
        >
            Català
        </button>
        <button type="button"
            (click)="selectLanguage('en')"
            [class.active]="isActive()('en')"
            class="floating-lang-option"
        >
            🇬🇧 English
        </button>
        <button type="button"
            (click)="selectLanguage('fr')"
            [class.active]="isActive()('fr')"
            class="floating-lang-option"
        >
            🇫🇷 Français
        </button>
        <button type="button"
            (click)="selectLanguage('zh')"
            [class.active]="isActive()('zh')"
            class="floating-lang-option"
        >
            🇨🇳 中文
        </button>
    </div>
    }
</div>
}